module.exports = __webpack_public_path__ + "static/media/burrito-cabreras.1877d3a3.jpg";